import React from "react";
// import { BsPatchCheck } from "react-icons/bs";
// import { IoWarningOutline } from "react-icons/io5";
// import { BsFileEarmarkArrowDown } from "react-icons/bs";
import DOMPurify from "dompurify";

/* eslint-disable react/prop-types */

export const TextAreaField = ({ name, handleChange, value, isEditable, required }) => {
	// const disabledInputs = [];
	// const isDisabled = disabledInputs.includes(name);

	return isEditable ? (
		<textarea
			value={value || ""}
			className='edit'
			name={name}
			onChange={handleChange}
			rows='2'
			style={{ width: "100%", border: "1px solid  #999999" }}
			required={required}
		/>
	) : (
		<span
			dangerouslySetInnerHTML={{ __html: value ? DOMPurify.sanitize(value) : "N/A" }}
			className='text_view'></span>
	);
};

// custom SelectField
export const CustomSelectField = ({ name, handleChange, value, options = [], isEditable, required }) => {
	// console.log(value,options )
	return isEditable ? (
		<select className='edit' name={name} onChange={handleChange} value={value} required={required}>
			<option value=''>--- Select ---</option>
			{options.map((option) => (
				<option key={option.name || option} value={option.name || option}>
					{option.name || option || null}
				</option>
			))}
		</select>
	) : (
		<div className='inputText text_view'>
			<span>{value ? value : "N/A"}</span>
		</div>
	);
};
